import { useMutation } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { IDwnloadCsvModel } from "../contracts/dwnloadCsvModel";

export function useDownloadCsvModelClean() {
  const { request } = usePbm2Url();

  return useMutation(async () => {
    const { Beneficiaries_downloadCsvModelClean } = await request(
      gql`
        mutation Beneficiaries_downloadCsvModelClean {
          Beneficiaries_downloadCsvModelClean {
            url
            errors {
              code
              message
            }
          }
        }
      `
    );

    return Beneficiaries_downloadCsvModelClean as IDwnloadCsvModel;
  });
}
